import { PickemDetails, PickemDetailsBase } from "../PickemDetails";
import { BracketemPointsRules } from "./PointsRules";

export type BracketemDetails = PickemDetailsBase & {
  pointsRules: BracketemPointsRules;
};

export const isBracketemDetails = (
  pickemDetails: PickemDetails
): pickemDetails is BracketemDetails => {
  return pickemDetails.pickemType === "Bracketem";
};
